module.exports = __webpack_public_path__ + "static/media/MOTO.cfbb09de.ico";